import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import StrategicConsulting from './pages/StrategicConsulting';
import InvestmentsLending from './pages/InvestmentsLending';
import ConstructionRealEstate from './pages/ConstructionRealEstate';
import Hospitality from './pages/Hospitality';
import Research from './pages/Research';
import IntelligentFinancing from './pages/IntelligentFinancing';
import PreciousMetals from './pages/PreciousMetals';
import AssetAdministration from './pages/AssetAdministration';
import Staff from './pages/Staff';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Login from './pages/Login';
import './App.css';

function App() {
  const backgroundStyle = {
    backgroundImage: 'url(/background.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <Router>
      <div className="bg-pattern min-h-screen" style={backgroundStyle}>
        <div className="bg-overlay min-h-screen">
          <Routes>
            {/* Login route without Layout */}
            <Route path="/login" element={<Login />} />
            
            {/* All other routes with Layout */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/strategic-consulting" element={<StrategicConsulting />} />
                  <Route path="/investments-lending" element={<InvestmentsLending />} />
                  <Route path="/construction-real-estate" element={<ConstructionRealEstate />} />
                  <Route path="/hospitality" element={<Hospitality />} />
                  <Route path="/research" element={<Research />} />
                  <Route path="/intelligent-financing" element={<IntelligentFinancing />} />
                  <Route path="/precious-metals" element={<PreciousMetals />} />
                  <Route path="/asset-administration" element={<AssetAdministration />} />
                  <Route path="/staff" element={<Staff />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;